export default __webpack_public_path__ + "images/models/b89abd399f2f8a868ffde41103679cb7.glb";